import Popconfirm from './Popconfirm'
export default Popconfirm
